export enum FILE_TYPE {
  APPLICATION_FORM = 'APPLICATION_FORM',
  APPLICATION_NOTICE = 'APPLICATION_NOTICE',
}
